import { render } from "./NcChip.vue?vue&type=template&id=5011c38d"
import script from "./NcChip.vue?vue&type=script&lang=js"
export * from "./NcChip.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__